import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "title"]
const _hoisted_2 = { class: "ml-2 connection-state" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex flex-row align-center justify-center",
    role: "status",
    "aria-label": _ctx.state.text,
    title: _ctx.state.text
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.state.class, "rounded-circle circle"])
    }, null, 2),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.state.text), 1)
  ], 8, _hoisted_1))
}